<template>
    <div>
        <ValidationObserver v-slot="{ handleSubmit }" v-if="!success">
            <form @submit.prevent="handleSubmit(submit)" action="#" class="login-form" :class="{'loading': loading}">

                <ValidationProvider
                    :name="$t('E-mail')"
                    rules="required|email"
                    tag="div"
                    class="form-group"
                    v-slot="{ errors }">

                    <input v-model="form.email" type="text" name="email" :placeholder="$t('E-mail')" class="form-control" :class="{ 'is-invalid': forgotPasswordFormErrors && forgotPasswordFormErrors.email }">
                    <span class="text-danger">{{ errors[0] }}</span>
                    <div class="alert alert-danger" v-if="forgotPasswordFormErrors && forgotPasswordFormErrors.email">
                        {{ forgotPasswordFormErrors.email[0] }}
                    </div>
                    <div class="alert alert-danger" v-if="forgotPasswordFormErrors && forgotPasswordFormErrors.message">
                        {{ forgotPasswordFormErrors.message }}
                    </div>
                </ValidationProvider>
                <google-re-captcha-v3
                    v-model="form.gRecaptchaResponse"
                    ref="captcha"
                    site-key="6LcYc50aAAAAAEO4r8anAbWprxsv_cbDse5KqSMP"
                    id="forgot_password_id"
                    inline
                    action="forgot_password"
                ></google-re-captcha-v3>

                <button type="submit" class="btn btn-primary mt-2" :disabled="formSubmitting">
                    <span v-if="!formSubmitting">{{ $t('Reset password') }}</span>
                    <span v-else>{{ $t('Reset password') + '...' }}</span>
                </button>
            </form>
        </ValidationObserver>
        <div class="alert alert-success" role="alert" v-else>
            {{ $t('You will receive an e-mail with a link to reset your password shortly. Please check your inbox now.') }}
        </div>
    </div>

</template>
<script>
import {mapActions, mapGetters} from 'vuex';
import GoogleReCaptchaV3 from "../googlerecaptchav3/GoogleReCaptchaV3";

export default {
    name: 'RestPasswordForm',
    components: {
        GoogleReCaptchaV3
    },

    data() {
        return {
            form: {
                email: '',
                gRecaptchaResponse: null,
            },
            captchaRef: null,
            forgotPasswordFormErrors: [],
            formSubmitting: false,
            success: false,
            loading: false,
        }
    },

    computed: {

        ...mapGetters({
            formErrors: 'auth/formErrors',
            authenticated: 'auth/authenticated',
            permissions: 'auth/permissions'
        }),

    },

    methods: {
        ...mapActions({
            signIn: 'auth/signIn'
        }),

        submit () {

            this.formSubmitting = true;
            this.loading = true;
            this.setCaptchaRef();

            axios.post('/api/forgot_password/email', this.form)
                .then(response => {
                    this.formSubmitting = false;
                    this.success = true;
                    this.loading = false;
                }).catch( error => {
                if (error.response.status === 422) { // Validation Error
                    this.forgotPasswordFormErrors = error.response.data.error;
                    this.formSubmitting = false;
                }
                this.loading = false;
            });
            this.captchaRef.execute();
            // Set login form state
            this.formSubmitting = false;

        },

        setCaptchaRef() {
            let captcha = this.$refs.captcha

            if (captcha && !this.captchaRef) {
                this.captchaRef = captcha;
            }
        },

    },

}
</script>
